/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDetailsRequest } from './';
import {
    ProjectDetailsRequestFromJSON,
    ProjectDetailsRequestFromJSONTyped,
    ProjectDetailsRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateReferralSubmissionProjectRequest
 */
export interface UpdateReferralSubmissionProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralSubmissionProjectRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralSubmissionProjectRequest
     */
    description: string;
    /**
     * 
     * @type {ProjectDetailsRequest}
     * @memberof UpdateReferralSubmissionProjectRequest
     */
    details?: ProjectDetailsRequest;
}

/**
 * Check if a given object implements the UpdateReferralSubmissionProjectRequest interface.
 */
export function instanceOfUpdateReferralSubmissionProjectRequest(value: object): value is UpdateReferralSubmissionProjectRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function UpdateReferralSubmissionProjectRequestFromJSON(json: any): UpdateReferralSubmissionProjectRequest {
    return UpdateReferralSubmissionProjectRequestFromJSONTyped(json, false);
}

export function UpdateReferralSubmissionProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralSubmissionProjectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'details': json['details'] == null ? undefined : ProjectDetailsRequestFromJSON(json['details']),
    };
}

export function UpdateReferralSubmissionProjectRequestToJSON(value?: UpdateReferralSubmissionProjectRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'description': value['description'],
        'details': ProjectDetailsRequestToJSON(value['details']),
    };
}

